import { CreateItemGqlError } from '../../../../types';
import {
  DeleteInvoiceCustomFieldCacheKeys,
  InvoiceCustomFieldID,
  InvoiceCustomFieldUUID
} from '../../invoiceCustomFieldsTypes';

import { CACHE_DELETE_INVOICE_CUSTOM_FIELD_QUERY } from '../../queries/cacheDeleteInvoiceCustomField.query';

import { useCacheDeleteQuery } from '../../../common/reactQuery/hooks/useCacheDeleteQuery';

interface CacheDeleteInvoiceCustomFieldOptions {
  cacheKeys?: DeleteInvoiceCustomFieldCacheKeys;
}

export interface CacheDeleteInvoiceCustomFieldInput {
  uuid: InvoiceCustomFieldID | InvoiceCustomFieldUUID;
}

export interface CacheDeleteInvoiceCustomFieldResponse {
  deleteInvoiceCustomField: {
    status: string;
    errors?: CreateItemGqlError;
  };
}

export interface CacheDeleteInvoiceCustomFieldError {
  fullMessages: string[];
}

const action = 'deleteInvoiceCustomField';

function useCacheDeleteInvoiceCustomField({
  cacheKeys
}: CacheDeleteInvoiceCustomFieldOptions = {}) {
  const {
    deleteCacheQuery,
    deleteCacheQueryData,
    deleteCacheQueryError,
    deleteCacheQueryErrorMessage,
    deleteCacheQueryLoading,
    deleteCacheQueryReset
  } = useCacheDeleteQuery<
    CacheDeleteInvoiceCustomFieldInput,
    CacheDeleteInvoiceCustomFieldResponse,
    CacheDeleteInvoiceCustomFieldError
  >({
    action,
    query: CACHE_DELETE_INVOICE_CUSTOM_FIELD_QUERY,
    cacheKeys
  });

  return {
    deleteInvoiceCustomField: deleteCacheQuery,
    deleteInvoiceCustomFieldData: deleteCacheQueryData,
    deleteInvoiceCustomFieldError: deleteCacheQueryError,
    deleteInvoiceCustomFieldErrorMessage: deleteCacheQueryErrorMessage,
    deleteInvoiceCustomFieldLoading: deleteCacheQueryLoading,
    deleteInvoiceCustomFieldReset: deleteCacheQueryReset
  };
}

export default useCacheDeleteInvoiceCustomField;
